import { createSlice } from "@reduxjs/toolkit"
import { SLICE_NAME } from "constants/common"

const initialState = {
    tableDataBackup: null,
    searchQueryBackup: {
        page: 0,
        size: 5    
    },
    refreshBackup: false
}

export const backupSlice = createSlice({
    name: SLICE_NAME.BACKUP,
    initialState,
    reducers: {
        setTableDataBackup: (state, action) => void(state.tableDataBackup = action.payload),
        setSearchQueryBackup: (state, action) => void(state.searchQueryBackup = action.payload),
        toggleRefreshBackup: (state, action) => void(state.refreshBackup = !state.refreshBackup)
    }
})

export const { setTableDataBackup, setSearchQueryBackup, toggleRefreshBackup } = backupSlice.actions
export default backupSlice.reducer